// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1Nrov","log":"ModalInventoryLogs_log__18lk7","date":"ModalInventoryLogs_date__2i8b6","userName":"ModalInventoryLogs_userName__s5pRK"};